module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentItems.length) ? _c('MentoringProgramsList', {
    attrs: {
      "items": _vm.currentItems
    }
  }) : _c('Warning', [_c('p', [_vm._v(_vm._s(_vm.warningText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ae2b85d","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/currentprograms/MentoringCurrentPrograms.vue
// module id = 2f6a5ad916410deaef63
// module chunks = 64